import React, { forwardRef } from 'react'
import * as styles from '../styles/components/border.module.scss'
import cx from 'classnames'
import { motion } from 'framer-motion'

export type BorderProps = Omit<React.HTMLProps<HTMLDivElement>, 'style'>

const Border = forwardRef<HTMLDivElement, BorderProps>(({ className, ...rest }, ref) => {
    return (
        <div className={cx(styles.border, className)} {...rest} ref={ref} />
    )
})

export default motion(Border)
